var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpacesIcon = function SvgSpacesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.377 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-8.825 4.818 4.808-3.492a3 3 0 0 1 1.864-.576 3.92 3.92 0 0 1 3.64 2.73q.42 1.311.765 1.773a7.49 7.49 0 0 0 5.997 2.997v3a10.48 10.48 0 0 1-8.103-3.82l-1.045 5.932 3.091 2.595 3.335 9.162-2.82 1.026-3.06-8.406-5.085-4.268a3 3 0 0 1-1.07-2.855l.764-4.328-1.015.738-3.191 4.392L9 18.654l3.527-4.854zm-.454 20.699 4.82-5.746 1.151-2.521L15.383 24l-1.12 3.27L9.8 32.589z",
    clipRule: "evenodd"
  })));
};
export default SvgSpacesIcon;